import React from "react";
import styled from "styled-components";
import defaultTheme from "./theme-test-override";
import { ThemeProps, ThemeTemplate } from "./theme-template";

type BlockLinkProps = {
    title?: string;
    url?: string;
    target?: string;
};

const Container = styled.div<ThemeProps>`
    overflow: hidden;
    border-radius: 4px;
    border: 1px solid ${props => props.theme.colors.monotoneMid};
    &:hover {
        border: 1px solid ${props => props.theme.colors.monotoneMidDark};
    }
    transition: border 0.5s ease-out;
    max-width: 25rem;
    position: relative;
    background: #fff;
`;

const Link = styled.a<ThemeProps>`
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    text-decoration: none;
    color: ${props => props.theme.colors.monotoneDark};
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='19' xmlns:v='https://vecta.io/nano'%3E%3Cpath d='M.719.121l-.29.29a.49.49 0 0 0 0 .696l8.018 8.018-8.018 8.018a.49.49 0 0 0 0 .696l.29.29a.49.49 0 0 0 .696 0l8.656-8.656a.49.49 0 0 0 0-.696L1.415.121a.49.49 0 0 0-.696 0z' fill='%23626466'/%3E%3C/svg%3E")
        no-repeat right 1rem center;
    padding: 1rem;
`;

const Title = styled.span`
    flex-grow: 3;
`;
Container.defaultProps = {
    theme: {
        ...defaultTheme
    } as ThemeTemplate
};

Link.defaultProps = {
    theme: {
        ...defaultTheme
    } as ThemeTemplate
};

const BlockLink = ({ title, url, target }: BlockLinkProps) => (
    <Container>
        <Link
            href={url}
            className="no-after"
            target={target}
            rel={`${target === "_blank" ? "noopener" : ""} noreferrer`}
        >
            <Title>{title}</Title>
        </Link>
    </Container>
);

export { BlockLink };
